module.exports = {
	"account.user.driving.licence.already.exist": "S tímto číslem řidičského oprávnění existuje jiný účet.",
	"account.user.login.already.exist": "Tento e-mail již používá jiný účet.",
	"account.user.suspended": "Tuto akci nelze provést, protože uživatel je pozastaven",
	"action.add.payment": "Přidat způsob platby",
	"action.complete.my.account": "Vyplňte můj účet",
	"action.confirm.welcome.msg": "Pojďme",
	"action.create.my.account": "Vytvořit můj účet",
	"action.search.update.bookings": "Ověřit dostupnosti",
	"action.update.payment": "Aktualizovat způsob platby",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Kliknutím na tlačítko „Potvrdit“ prohlašujete čestným prohlášením, že souhlasíte s pravidly a podmínkami služby, a pokud používáte službu sdílení automobilů, máte v současné době platné řidičské oprávnění. Více v {link}.",
	"booking.accept_usage_terms.title": "Podmínky použití",
	"booking.action.cancel.forbidden": "Rezervaci již nelze zrušit",
	"booking.action.edit.forbidden": "Rezervaci již nelze upravovat",
	"booking.add.calendar": "Přidat do kalendáře",
	"booking.confirm": "Potvrdit rezervaci",
	"booking.confirm_and_pay": "Potvrdit a zaplatit",
	"booking.deposit": "Kauce",
	"booking.deposit.b": "Po potvrzení rezervace bude účtována bankovní záloha ve výši {damageSafetyDeposit} {currency}\n Tato záloha může být použita na pokrytí veškerých škod způsobených na vozidle během vaší cesty. \n\n Pokud bude vozidlo vráceno bez poškození nebo přesčasů, bude účtována {bookingPrice} {currency}",
	"booking.deposit.d": "Po potvrzení rezervace bude proveden bankovní vklad ve výši {bufferPrice} {currency}\n To zahrnuje cenu rezervace a poplatek za případné překročení. \n\n Bez překročení nebo poškození vozidla bude z vašeho účtu odečtena {bookingPrice} {currency}",
	"booking.deposit.db": "Po potvrzení rezervace budou účtovány dva bankovní vklady:\n - První ve výši {bufferPrice} {currency} , včetně ceny vaší rezervace a poplatku na pokrytí případných překročení.\n - Druhý ve výši {damageSafetyDeposit} {currency} k pokrytí škod způsobených na vozidle během rezervace. \n\n Bez překročení nebo poškození vozidla bude účtována {bookingPrice} {currency}",
	"booking.deposit.info": "Za vaši rezervaci bude složena záloha",
	"booking.payment.prebilling.refused.error": "Transakce byla odmítnuta, protože zůstatek na vaší kreditní kartě je nedostatečný. Zkuste to znovu s jinou kartou. Pokud problém přetrvává, obraťte se na svou banku.",
	"booking.payment.prebilling.technical.error": "Během platby došlo k chybě. Zkuste to znovu později.",
	"booking.success.sub.title": "Děkujeme vám za využití naší služby!",
	"booking.success.title": "Gratulujeme, vaše rezervace byla úspěšně vytvořena!",
	"booking.type.label": "Typ rezervace",
	"booking.type.one_way": "Jednosměrně",
	"booking.type.return_trip": "Zpáteční cesta",
	"booking.update.period.expired": "Lhůta pro aktualizaci termínů rezervace vypršela",
	"booking.usage.business": "Firemní",
	"booking.usage.private": "Soukromé",
	"booking.view_payment_terms.title": "Platební podmínky",
	"booking.voucher.different.code": "Nemůžete měnit svůj propagační kód",
	"booking.voucher.placeholder": "I have a voucher code",
	"car.AUTOMATIC": "Automatická",
	"car.DIESEL": "Nafta",
	"car.ELECTRIC": "Elektřina",
	"car.FOLDING_SEATS": "Sklopná sedadla",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrid",
	"car.LPG": "GPL",
	"car.MANUAL": "Ruční",
	"car.PETROL": "Benzín",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Podrobnosti o rezervaci",
	"car.color": "Barva",
	"car.compact_cars": "Kompaktní",
	"car.description": "Description",
	"car.details": "Podrobnosti o vozidle",
	"car.doors": "Dveře",
	"car.filter.COMMERCIAL": "Obchodní",
	"car.filter.PASSENGER": "Turistika",
	"car.filter.accessories.air_conditioning": "Klimatizace",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Velký nákladní automobil",
	"car.filter.accessories.radio_cd": "Rádio",
	"car.filter.label_nb_persons": "Počet osob",
	"car.filter.other": "Ostatní",
	"car.filter.other-nb": "Ostatní - {nb}",
	"car.filter.vehicle_type": "Typ vozidla",
	"car.filter_energy": "Energie",
	"car.filter_gearbox_type": "Typ převodovky",
	"car.filter_persons": "lidé",
	"car.for_every_additional_km": "Za další kilometr",
	"car.km_included": "Kilometry v ceně",
	"car.motorization": "Motorizace",
	"car.options": "Možnosti",
	"car.parking_additional_info": "Podrobnosti o parkování",
	"car.places": "Sedadla",
	"car.pricing": "Ceny",
	"car.pricing.estimate": "Odhad ceny",
	"car.pricing.extra_km_cost_per_day": "Cena za km navíc",
	"car.pricing.free_km_per_day": "km v ceně/24 hodin",
	"car.specifications": "Specifikace",
	"car.transmission": "Převodovka",
	"car.utility_cars": "Užitková",
	"car.version": "Verze",
	"company.id.missing.booking.search": "ID společnosti je povinné pro anonymní vyhledávání rezervací",
	"contact_page.phone_call_price": "(VOLÁNÍ ZDARMA Z PEVNÉ LINKY)",
	"contact_page.title_1": "S veškerými dotazy ohledně vašeho nájmu vozidla",
	"contact_page.title_2": "neváhejte nás kontaktovat e-mailem.",
	"creditcard.data.insufficient.3ds": "Z důvodu nových požadavků na 3DS2 vás žádáme o aktualizaci platebních údajů.",
	"custom.field.type.boolean": "Ano/Ne",
	"data.with.colon": "{data}:",
	"document.issue.date": "Datum vydání",
	"dropzone.inner.info": "Povoleny jsou soubory: JPG, PNG, PDF",
	"dropzone.inner.title": "Odešlete svůj dokument",
	"error.booking.member_invalid": "Váš profil zatím nebyl vyhodnocen.",
	"error.booking.no.usage": "Pro tato data rezervace není použití",
	"error.booking.no_credit_card": "Nejdříve přidejte informace o své kreditní kartě.",
	"error.booking.same_period": "Na toto období již máte naplánovanou rezervaci.",
	"error.change_password.400.bad_request": "Heslo je nesprávné",
	"error.contract.inactive": "Služba pro vaši společnost není aktivní, obraťte se na svého správce služeb.",
	"error.contract.not-found": "Služba je pozastavena vaší společností, obraťte se na svého správce služeb.",
	"error.credit.card.refused": "Kreditní karta odmítnuta",
	"error.forgot_password.404": "Zkontrolujte svůj e-mail, žádný účet neodpovídá",
	"error.form.email.already_exists": "Zadejte jinou e-mailovou adresu",
	"error.form.email_invalid": "Zadejte platný e-mail",
	"error.form.inviteCode.notEmpty": "Uveďte kód pozvánky",
	"error.form.password.at_least": "Vaše heslo musí obsahovat nejméně 8 znaků",
	"error.form.password.at_most": "Vaše heslo smí obsahovat nejvýše 25 znaků",
	"error.form.password.cannot_reset_same": "Vaše nové heslo se musí lišit od současného",
	"error.form.password.digit": "Vaše heslo musí obsahovat 1 číslici",
	"error.form.password.lower_letter": "Vaše heslo musí obsahovat 1 malé písmeno",
	"error.form.password.upper_letter": "Vaše heslo musí obsahovat 1 velké písmeno",
	"error.form.password_confirmation.the_same": "Zadejte dvakrát stejné heslo",
	"error.form.password_old.the_same": "Nové heslo se musí lišit od předchozích použitých hesel",
	"error.form.required": "Vyplňte všechna povinná pole",
	"error.form.suggestion.address.required": "Vyberte adresu ze seznamu návrhů",
	"error.form.technical": "Technická chyba",
	"error.get.site.config": "Načtení konfigurace webu se nezdařilo",
	"error.invite.code.invalid": "Komunita, ke které se chcete připojit, neexistuje",
	"error.login.401.unauthorized": "Váš e-mail nebo heslo jsou nesprávné",
	"error.login.403.user.anonymized": "Váš účet je anonymizován, už ho nemůžete používat",
	"error.login.422.user.not.enabled": "Váš účet není aktivován. Zkontrolujte své e-maily a účet aktivujte podle pokynů.",
	"error.number.above.max": "Hodnota nesmí být vyšší než {value}",
	"error.number.below.min": "Hodnota nesmí být nižší než {value}",
	"error.phone.format.invalid": "Formát telefonního čísla je nesprávný",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Chyba požadavku",
	"error.reset_password.401": "Poskytnutý odkaz již není platný, vyžádejte si od webových stránek jiné heslo",
	"error.search.vehicles.403": "K aktuálnímu aktivnímu profilu nelze přistupovat k vybranému webu",
	"error.session.expired": "Relace vypršela",
	"error.text.length.long": "Toto pole je omezeno na {count} znaků",
	"error.text.length.short": "Toto pole vyžaduje alespoň {count} znaků",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Po ověření Vašeho profilu nelze změnit jméno ani datum narození",
	"faq.contactEmailFallback": "náš kontaktní e-mail",
	"faq.contactPhoneFallback": "dolní části stránky",
	"faq.other_question": "Nemůžete najít odpověď na svou otázku?",
	"file_upload_size_exceeded": "Soubor je příliš velký. Maximální velikost: 5 MB",
	"footer.label.legal.information": "Legální informace",
	"footer.label.personal.data": "Osobní data",
	"footer_callUs": "Zavolejte nám",
	"footer_other": "Další",
	"footer_share": "Sledujte nás",
	"footer_society_about": "O nás",
	"footer_society_policy_privacy": "Zásady ochrany osobních údajů",
	"footer_society_term": "Podmínky použití",
	"footer_writeUs": "Napište e-mail",
	"forgot_password.confirmation": "Na vaši e-mailovou adresu byl odeslán odkaz na resetování vašeho hesla.",
	"forgot_password.description_line1": "Zadejte e-mail spojený s vaším účtem.",
	"forgot_password.description_line2": "Zašleme vám odkaz k resetování vašeho hesla.",
	"forgot_password.submit": "Pošlete mi resetovací odkaz",
	"generic.address": "Adresa",
	"generic.at": "v",
	"generic.book": "Rezervovat",
	"generic.cancel": "Zrušit",
	"generic.canceled": "Zrušeno",
	"generic.city": "Město",
	"generic.clear": "Smazat",
	"generic.company": "Společnost",
	"generic.completed": "Dokončeno",
	"generic.country": "Země",
	"generic.email": "E-mail",
	"generic.end": "Konec",
	"generic.expires.at": "Platnost uplyne",
	"generic.extend": "Rozšířit",
	"generic.file": "Soubor",
	"generic.first.name": "Jméno",
	"generic.last.name": "Příjmení",
	"generic.location.fixture.label": "Místa",
	"generic.location.history.label": "Dějiny",
	"generic.location.search.placeholder": "Vyhledat adresu, město...",
	"generic.mobile.phone": "Mobilní telefon",
	"generic.modify": "Modifikovat",
	"generic.mr": "Pan",
	"generic.mrs": "Paní",
	"generic.next": "Další",
	"generic.number": "Číslo",
	"generic.passport": "Pas",
	"generic.past.placeholder": "Zde naleznete své minulé rezervace",
	"generic.phone.number": "Telefonní číslo",
	"generic.postal.code": "PSČ",
	"generic.retry": "Opakovat",
	"generic.save": "Uložit",
	"generic.send": "Odeslat",
	"generic.start": "Start",
	"generic.text": "Text",
	"generic.today": "Dnes",
	"generic.upcoming": "Nadcházející",
	"generic.updated": "Aktualizováno",
	"generic.user": "Uživatel",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Chcete-li se registrovat, jednoduše přejděte na intranetový web vaší společnosti, najdete zde odkaz, který vás přesměruje na stránku pro registraci (Nebo pošlete žádost o přihlášení na adresu {contactEmail}). Odkaz obdržíte e-mailem.",
	"helpPage_carSharing_issue1_title": "Jak se zaregistrovat?",
	"helpPage_carSharing_issue2_answer": "Heslo můžete resetovat z webu nebo mobilních aplikací: v tomto případě obdržíte na registrovanou e-mailovou adresu odkaz na nastavení nového hesla.",
	"helpPage_carSharing_issue2_title": "Co když ztratím heslo?",
	"helpPage_carSharing_issue3_answer": "V případě, že ztratíte svůj odznak nebo máte nový, kontaktujte prosím telefonické centrum na {contactPhone} a resetujte svůj čip. Nový čip nebude fungovat, dokud nebude nejprve resetován.",
	"helpPage_carSharing_issue3_title": "Co když ztratím odznak nebo mám nový?",
	"helpPage_carSharing_issue4_answer": "Registrační značka Vašeho vozidla je uvedena v potvrzovacím e-mailu a v potvrzovací SMS. Jinak najdete vozidlo na rezervační stránce Moje rezervace.",
	"helpPage_carSharing_issue4_title": "Které vozidlo jsem si rezervoval/a?",
	"helpPage_carSharing_issue5_answer": "Ujistěte se, že datum a čas jsou správné, tlačítko Start je k dispozici pouze od okamžiku rezervace. V opačném případě můžete přejetím čipu po čtečce karet otevřít dveře vozidla.",
	"helpPage_carSharing_issue5_title": "Proč nemohu najít tlačítko Start?",
	"helpPage_carSharing_issue6_answer": "Pokud jste provedl/a rezervaci a kontrolka svítí zeleně, ale dveře se neotevřou, stiskněte tlačítko umístěné na klice dveří.",
	"helpPage_carSharing_issue6_title": "Proč svítí zelené světlo, ale dveře jsou stále zavřené?",
	"helpPage_carSharing_issue7_answer": "Jakmile si rezervujete vozidlo, můžete také upravit nebo zrušit svou rezervaci z webu nebo mobilní aplikace. Pokud potřebujete pomoc, kontaktujte prosím telefonické centrum na čísle {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Upravit / Zrušit",
	"helpPage_carSharing_issue8_answer": "Čipem nelze přejíždět předem, vozidlo můžete otevřít až ve správný čas.",
	"helpPage_carSharing_issue8_title": "Mohu čipem přejet předem?",
	"helpPage_damages_issue1_answer": "Před zahájením rezervace je nutné upozornit na škody v mobilní aplikaci nebo telefonicky na čísle {contactPhone}.",
	"helpPage_damages_issue1_title": "Co dělat v případě, že je rezervované vozidlo poškozené?",
	"helpPage_damages_issue2_answer": "Zachovejte klid a ujistěte se, že nikdo není zraněn. Kryje Vás pojistka. Co nejdříve se spojte s telefonickým centrem na čísle {contactPhone}, kde získáte další pokyny.",
	"helpPage_damages_issue2_title": "Co dělat v případě nehody během mé rezervace?",
	"helpPage_subtitle": "V této části naleznete odpovědi na nejčastější dotazy.",
	"helpPage_tab_carSharing": "Služba",
	"helpPage_tab_damages": "Škody",
	"helpPage_tab_vehicles": "Vozidlo",
	"helpPage_title": "Nejčastější dotazy (FAQ)",
	"helpPage_vehicles_issue1_answer": "Zkontrolujte datum a čas rezervace a poté zkontrolujte, zda se registrační značka shoduje s Vaší rezervací. Poté znovu přejeďte POUZE čipem před čtečkou. Ujistěte se, že používáte čip, který patří stejné osobě, která provedla rezervaci, a že se mezi poslední rezervací nezměnila. V případě nedávné změny čipu se, prosím, obraťte na zákaznický servis a proveďte rychlou změnu.",
	"helpPage_vehicles_issue1_title": "Proč vozidlo nereaguje?",
	"helpPage_vehicles_issue2_answer": "Zkontrolujte data a hodiny rezervace a poté zkontrolujte, zda se registrační značka shoduje s Vaší rezervací. Ujistěte se, že vlastníte správný čip (čip osoby, která provedla rezervaci).",
	"helpPage_vehicles_issue2_title": "Proč se na čtečce karet zobrazuje jen červené světlo?",
	"helpPage_vehicles_issue3_answer": "Pokud máte rezervaci a kontrolka je zelená, ale neslyšíte odemknutí dveří, stisknutím tlačítka na dveřích řidiče odemknete dveře.",
	"helpPage_vehicles_issue3_title": "Proč zůstávají dveře zavřené?",
	"helpPage_vehicles_issue4_answer": "Zkontrolujte si registrační značku vozu, Vaše datum a čas, ujistěte se, že máte dostatečné připojení k Internetu.",
	"helpPage_vehicles_issue4_title": "Proč nemohu otevřít dveře?",
	"helpPage_vehicles_issue5_answer": "Zkontrolujte, že je motor vypnutý, dveře a zavazadlový prostor jsou správně zavřené, že jste klíče nechal/a s malým čipem do krabice umístěné v odkládací přihrádce.",
	"helpPage_vehicles_issue5_title": "Proč nemohu vozidlo zamknout?",
	"home.header_banner": "V říjnu se z <strong> Renault Mobility </strong> stane <strong> Mobilize share </strong>",
	"home.welcome": "Vítejte v aplikaci {productName}",
	"home.welcome_solo": "Vítejte",
	"how_it_works.step_1": "<span class='bold'>Stáhněte si aplikaci</span> z obchodu App Store nebo Google Play.",
	"how_it_works.step_2": "Spusťte aplikaci a <span class='bold'>zaregistrujte se</span> vyplněním formuláře.",
	"how_it_works.step_3": "Pořiďte snímek svého <span class='bold'>řidičského oprávnění</span>, svého <span class='bold'>průkazu totožnosti</span> a <span class='bold'>svůj vlastní snímek</span> s vaším průkazem totožnosti v blízkosti svého obličeje a vše uložte v aplikaci!",
	"how_it_works.step_4": "Abyste mohli spravovat platbu svého nájmu, <span class='bold'>zaregistrujte svou bankovní kartu</span>.",
	"how_it_works.step_5": "<span class='bold'>Ověřte svou e-mailovou adresu</span> kliknutím na odkaz, který jste obdrželi. <span class='bold'>Zkontrolujte své složky nevyžádané pošty (SPAM)</span>.",
	"how_it_works.step_6": "Po vyhodnocení vaší registrace si v naší aplikaci nebo na našich webových stránkách <span class='bold'>rezervujte své vozidlo</span>. V den rezervace <span class='bold'>je klíčem váš smartphone!</span>",
	"info.account.company.already.linked": "Tato společnost je již propojena s vaším účtem",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Přepínání profilu",
	"info.worldpay.return.success": "Přiložené platební údaje",
	"iso__BE": "Belgie",
	"iso__CS": "Česko",
	"iso__DA": "Dánsko",
	"iso__DE": "Německo",
	"iso__ES": "Španělsko",
	"iso__FR": "Francie",
	"iso__IT": "Itálie",
	"iso__NL": "Nizozemsko",
	"iso__PL": "Polsko",
	"iso__PT": "Portugalsko",
	"iso__SL": "Slovinsko",
	"iso__SV": "Švédsko",
	"iso__pt_BR": "Brazílie",
	"label.accept_terms_and_conditions": "Souhlasím s tím, že budu za účelem šetření nebo informací o nových produktech a aktuálních nabídkách následně kontaktován prostřednictvím e-mailu společností Renault a její sítí. U příležitosti každé zaslané zprávy budu mít možnost ukončit veškerou komunikaci.",
	"label.account.already.active": "Váš účet je již aktivní",
	"label.account_activation_description": "Jakmile bude váš účet ověřen, obdržíte potvrzení a budete moci využívat všech výhod služeb.",
	"label.account_activation_title": "Váš účet bude vyhodnocen nejpozději za 15 minut.",
	"label.activation.link.expired": "Platnost odkazu pro aktivaci uplynula",
	"label.activation.link.send": "Znovu odeslat",
	"label.activation.link.sent.success": "Pokud uživatel existuje a účet není aktivován, bude odeslán e-mail s aktivací",
	"label.active.profile": "Aktivní profil",
	"label.actual.payment.method": "Váš aktuální způsob platby",
	"label.add.new.profile": "Přidat nový profil",
	"label.apply": "Použít",
	"label.are_you_sure_you_want_to_cancel": "Chcete potvrdit své zrušení?",
	"label.birth.day": "Datum narození",
	"label.booking": "Rezervace",
	"label.booking.past": "Minulé",
	"label.booking.past.placeholder": "Zde najdete historii svých rezervací.",
	"label.booking.today.part": "dnes v",
	"label.booking.upcoming.placeholder": "Zde najdete své naplánované a probíhající rezervace",
	"label.cancel_my_booking": "Zrušit mou rezervaci",
	"label.car": "vozidlo",
	"label.carSharing": "Sdílení auta",
	"label.cars": "vozidla",
	"label.civility": "Manželský stav",
	"label.click_here": "Klikněte sem",
	"label.close": "Zavřít",
	"label.confirm_new_password": "Potvrdit heslo",
	"label.congratulations": "Gratulujeme!",
	"label.continue": "Pokračovat",
	"label.creditCard_message": "Za účelem vyhodnocení vaší karty bude provedeno dočasné inkaso z vašeho účtu. Na účtu spojeném s vaší kartou se může dočasně objevit zaúčtovaná malá částka ve výši {amountToTake} €. Jestliže bude zaúčtování této částky přetrvávat na vašem účtu déle než pět pracovních dní, obraťte se na svou banku.",
	"label.date": "Datum",
	"label.delivery_place": "Vydejte město",
	"label.driving_licence": "Řidičské oprávnění",
	"label.driving_licence_back": "Řidičské oprávnění (zadní strana)",
	"label.driving_licence_front": "Řidičské oprávnění (přední strana)",
	"label.edit.invite.code": "Upravte kód pozvánky",
	"label.expiration_date": "Datum konce platnosti",
	"label.file.upload.only.mobile": "K úpravě dokumentů použijte mobilní aplikaci.",
	"label.filter_by": "Filtrovat podle",
	"label.filters": "Filtry",
	"label.generic.error": "Došlo k chybě. Zkuste to znovu později.",
	"label.hours": "hodiny",
	"label.how_it_works": "Jak to funguje?",
	"label.identity.card": "Průkaz totožnosti",
	"label.identity.document.number": "Číslo průkazu totožnosti",
	"label.identity.document.type": "Typ průkazu totožnosti",
	"label.identity_card": "Průkaz totožnosti",
	"label.identity_card_back": "Průkaz totožnosti (zadní strana)",
	"label.identity_card_front": "Průkaz totožnosti (přední strana)",
	"label.identity_card_selfie": "Selfie s vaším průkazem totožnosti",
	"label.invite_code_placeholder": "Zadejte svůj kód pozvánky",
	"label.italy.fiscal.code": "Zadejte fiskální číslo",
	"label.italy.resident": "Jste Ital?",
	"label.licence_number": "Číslo řidičského oprávnění",
	"label.load_more": "Další výsledky",
	"label.login": "Přihlásit se",
	"label.logout": "Odhlásit se",
	"label.manager.email": "E-mail Vašeho nadřízeného",
	"label.mandatory_fields": "* Povinná pole",
	"label.member_already": "Jste již členem?",
	"label.my_account": "Můj účet",
	"label.my_reservations": "Mé rezervace",
	"label.new.password": "Nové heslo",
	"label.no_account": "Nový člen?",
	"label.or_by_phone": "Nebo telefonicky",
	"label.password": "Heslo",
	"label.password_forgot": "Zapomenuté heslo",
	"label.phone": "Telefon",
	"label.phone.suffix": "Koncovka telefonního čísla",
	"label.plateNumber": "Číslo desky",
	"label.price": "cena",
	"label.redirectMobileApp": "Chcete-li začít svou rezervaci, stáhněte si naši mobilní aplikaci!",
	"label.remember_me": "Zůstaňte přihlášeni v",
	"label.reset_password_done": "Vaše heslo bylo aktualizováno",
	"label.return": "Zpět",
	"label.schedule": "Hodiny",
	"label.search": "Hledat",
	"label.selected.language": "Vybraný jazyk",
	"label.subject": "Předmět",
	"label.switch.profile": "Přepnout profil",
	"label.the": "až",
	"label.validate": "Ověřit",
	"label.vehicles_found": "Počet nalezených výsledků {count}",
	"label.warning": "Varování",
	"label.welcome.finish.registration": "Chcete-li potvrdit svůj termín, dokončete prosím registraci.",
	"label.you_are_trying_to_cancel_your_booking": "Právě rušíte svou rezervaci!",
	"label.your.active.profile": "Váš aktivní profil",
	"label.your.other.profiles": "Vaše další profily",
	"label.your_message": "Vaše zpráva",
	"language.header": "Vyberte svůj jazyk",
	"login.forgot_password": "Zapomněli jste heslo?",
	"login.register": "Registrace",
	"menu.faq": "Informace",
	"mobile_banner.text": "Stáhněte si aplikaci {productName}",
	"page.password.update.sub.title": "Z bezpečnostních důvodů vás žádáme o aktualizaci hesla",
	"page.password.update.title": "Aktualizace hesla",
	"parking.special_opening_legend": "Zvláštní otevírací doba",
	"part.company.fill.extra.info": "žádá vás o vyplnění některých dalších údajů.",
	"part.complete.register.for": "Dokončete svou registraci na",
	"part.create.account.for": "Vytvořte účet pro",
	"part.link.account.to": "Propojte svůj účet s",
	"part.your.email": "tvůj email",
	"placeholder.enter.number": "Zadejte číslo ...",
	"placeholder.enter.text": "Sem napište ...",
	"placeholder.search": "Hledat ...",
	"profile.422.error.info": "Zdá se, že ve vašem profilu chybí některé informace.\n Pojďme společně ověřit váš profil, abychom se ujistili, že je vše v pořádku.",
	"profile.info.new.email": "Jestliže budete aktualizovat svou e-mailovou adresu, obdržíte e-mail k ověření vaší e-mailové adresy. Bez jejího ověření již nebudete moci vytvářet rezervaci.",
	"profile.label.before.arrival": "Před příjezdem",
	"profile.label.before.departure": "Před odjezdem",
	"profile.label.charges.call.center": "Pro změny provedené call centrem",
	"profile.label.charges.my": "Pro změny provedené mnou",
	"profile.label.current.password": "Aktuální heslo",
	"profile.label.expiration.date.status": "Můj řidičský průkaz nemá datum vypršení platnosti",
	"profile.label.min.15": "15 minut",
	"profile.label.min.30": "30 minut",
	"profile.label.min.45": "45 minut",
	"profile.label.new.email": "Nová e-mailová adresa",
	"profile.label.street.field": "Adresa (název ulice a číslo domu)",
	"profile.label.validated.email": "Vaše vyhodnocená e-mailová adresa",
	"profile.section.additional.info": "Doplňující informace",
	"profile.section.credentials": "Pověření",
	"profile.section.language": "Jazyk profilu",
	"profile.section.notifications": "Oznámení a upozornění",
	"profile.section.payment.info": "Informace o platbě",
	"profile.section.personal.info": "Osobní údaje",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Přístup techniků",
	"profile.select.menu.item": "Vlevo vyberte položku nabídky",
	"profile.selfie.section.info": "Pořiďte selfie, na kterém bude váš průkaz totožnosti vedle vaší tváře.",
	"profile.suspended": "Váš profil je pozastaven",
	"profile.title.email.notifications": "E-mailová oznámení",
	"profile.title.language.select": "Jazyk používaný pro oznámení a e-maily",
	"profile.title.sms.notifications": "SMS oznámení",
	"profile.title.update.email": "Aktualizujte svou e-mailovou adresu",
	"profile.title.update.password": "Aktualizujte své heslo",
	"profile_error_driver_license_invalid": "Řidičské oprávnění není platné",
	"register.field.info.password": "Musí obsahovat alespoň 1 číslo, 1 velké písmeno, 1 malé písmeno a 8 až 25 znaků",
	"register.info.payment.saved": "Způsob platby je uložen.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Na {email} byl zaslán aktivační odkaz.  Před uplynutím platnosti odkazu zkontrolujte své e-maily a složku s nevyžádanou poštou a podle pokynů aktivujte svůj účet.",
	"register.terms.ads": "Souhlasím se zpracováním svých údajů pro marketingové účely (automatizovanými i tradičními metodami) v souvislosti s produkty a/nebo službami mobility.",
	"register.terms.prefix.accept": "Přijímám",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "zásady ochrany osobních údajů",
	"register.terms.root.tos": "podmínky odběru",
	"register.terms.root.tou": "podmínky použití",
	"register.terms.suffix.ads": "použití mých osobních údajů ke komerčním účelům",
	"register.terms.suffix.of": "z",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Gratulujeme {firstName}, Váš účet byl vytvořen",
	"register.title.account.linked": "Gratulujeme {firstName}, nový profil byl propojen s vaším účtem",
	"register.title.account.updated": "Gratulujeme {firstName}, Váš účet byl aktualizován",
	"reset_password.title": "Reset hesla",
	"search.filter_alphabetically": "Abecedně",
	"search.filter_by": "Řadit podle",
	"search.filter_by_price": "Podle ceny",
	"search.result.empty": "Žádný výsledek",
	"service.corporate.intro": "Chcete se zapojit do komunity? Zadejte svůj kód pozvánky.",
	"service.intro_label": "Kterou službu {productName} si chcete předplatit?",
	"service.private.intro": "Chcete si rezervovat vozidlo ze sítě {productName}?",
	"service.private.renaultfr": "Chcete-li se přihlásit k odběru {productName}, stáhněte si příslušnou aplikaci ve svém obchodu s mobilními aplikacemi.",
	"service.private.select_country": "Vyberte zemi",
	"service.usage.corporate": "Sdílení firemních vozidel",
	"service.usage.private": "Půjčovna aut 24/7",
	"service.usage.vr": "Náhradní vozidlo",
	"service.vr.intro": "Děkujeme vám za váš zájem o naše služby!\n\nChcete-li se stát členy, obraťte se na své obchodní zastoupení a získejte odkaz k registraci.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Zadejte svou pracovní e -mailovou adresu",
	"sso.login.title": "Připojte se pomocí SSO",
	"status.APPROVED": "Profil ověřen",
	"status.NOT_APPROVED": "Váš profil byl odmítnut. Aktualizujte prosím svůj profil.",
	"status.TO_COMPLETE": "Nedokončeno",
	"status.TO_REVIEW": "Váš profil čeká na ověření",
	"tagline": "Samoobslužný pronájem vozů 24/7",
	"title.add.payment.later": "Můžete jej přidat později.",
	"title.add.payment.method": "Přidejte způsob platby.",
	"title.bookings.welcome.tutorial": "Najděte zde svou rezervaci, je již naplánovaná",
	"title.modify.booking": "Změnit mou rezervaci",
	"title.password.change.success": "Vaše nové heslo bylo uloženo",
	"title.update.booking": "Aktualizovat rezervaci",
	"title.welcome.to.brand": "Dobrý den, {firstName}, vítejte v {brandName}.",
	"title.welcome.to.program": "Dobrý den, {firstName}, vítejte v programu {brandName} {program}.",
	"vehicle.incorrect.usage": "Vozidlo není pro tento typ použití k dispozici",
	"week.day.friday": "Pátek",
	"week.day.monday": "Pondělí",
	"week.day.saturday": "Sobota",
	"week.day.sunday": "Neděle",
	"week.day.thursday": "Čtvrtek",
	"week.day.tuesday": "Úterý",
	"week.day.wednesday": "Středa"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/cs.json
 ** module id = 418
 ** module chunks = 0
 **/